import React from 'react';
import { motion } from 'framer-motion';
import { IDS } from '@/constants/testIds';

const REVIEWS = [
  {
    name: 'Анна Р.',
    tour: 'Золотой треугольник',
    text: 'Али — это невероятно душевный, эрудированный человек. Организация — безупречная, ни одной проблемы за 5 дней. Индия открылась нам совсем не той, что мы боялись. Спасибо!',
  },
  {
    name: 'Юлия С.',
    tour: 'Дивали 2025',
    text: 'Провели Дивали в семье местных — до сих пор мурашки. Али подобрал маршрут с учётом наших вкусов. Отдельная благодарность за отель на крыше в Джайпуре.',
  },
  {
    name: 'Ольга М.',
    tour: 'Индия для искателей',
    text: 'Восемь дней трансформации. Йога в Ришикеше на рассвете, лодка по Гангу, храмы Кхаджурахо. Али подстраивал темп под нас. Вернусь ещё.',
  },
  {
    name: 'Елена и Мария',
    tour: 'Девичник 8 марта',
    text: 'Мы вернулись другими. Али и его команда сделали невозможное — организовали и духовную часть, и праздник, и шопинг. Пойдём снова на следующий год!',
  },
];

export default function Reviews() {
  return (
    <section id="reviews" data-testid={IDS.sectionReviews} className="py-24 md:py-40 bg-espresso border-t border-border/60">
      <div className="container-x">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="mb-14 md:mb-20 max-w-3xl"
        >
          <p className="overline mb-4">№ 06 · Voices</p>
          <h2 className="font-serif-display text-5xl md:text-6xl lg:text-7xl leading-none">
            Что говорят те,<br /><em className="text-saffron">кто уже вернулся</em>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
          {REVIEWS.map((r, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.8, delay: i * 0.08 }}
              className="border-l-2 border-saffron pl-6 md:pl-8"
            >
              <blockquote className="font-serif-display text-xl md:text-2xl italic leading-snug text-foreground/90">
                “{r.text}”
              </blockquote>
              <figcaption className="mt-6 flex items-baseline justify-between">
                <span className="font-medium text-foreground">{r.name}</span>
                <span className="text-xs uppercase tracking-widest2 text-foreground/50">{r.tour}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>

        <div className="mt-14 md:mt-20 text-center">
          <a
            href="https://experience.tripster.ru/guide/132942/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-4 text-xs uppercase tracking-widest2 font-bold text-saffron border-b border-saffron pb-1 hover:opacity-70 transition-opacity"
          >
            Все отзывы на Tripster
            <span>↗</span>
          </a>
        </div>
      </div>
    </section>
  );
}
